<template lang="pug">
  div(:class="b()")
    figure(:class="b('logo')")
      img(:src="$projectConfig.get('COMPANY_LOGO')")
</template>

<script>
  export default {
    name: 'desktop-header',
  };
</script>

<style lang="sass" scoped>
  .desktop-header
    display: flex
    align-items: center
    padding: 35px 50px 28px 50px

    a
      color: inherit

    &__logo
      height: 43px

      img
        width: auto
        height: 100%

</style>